import script from "./labelSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./labelSetting.vue?vue&type=script&setup=true&lang=js"

import "./labelSetting.vue?vue&type=style&index=0&id=6274a1da&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6274a1da"]])

export default __exports__